import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <section className="mx-auto flex w-full max-w-2xl flex-col items-center gap-6 px-4 py-24 text-center">
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-jg-fg-muted">
        404 · face not found
      </p>
      <h1 className="font-display text-4xl font-semibold tracking-tight">
        The cube has only six faces.
      </h1>
      <p className="text-jg-fg-muted">
        That route isn’t one of them — yet.
      </p>
      <Link
        to="/"
        className="rounded-full bg-jg-fg px-4 py-1.5 text-sm font-medium text-jg-bg hover:opacity-90"
      >
        Back to the cube
      </Link>
    </section>
  );
}
